import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 1,
      title: "Post New Job",
      description: "Create and publish a new job opening",
      icon: "PlusCircle",
      iconColor: "var(--color-primary)",
      bgColor: "bg-primary/10",
      path: "/post-new-job"
    },
    {
      id: 2,
      title: "View All Candidates",
      description: "Browse candidate database",
      icon: "Users",
      iconColor: "var(--color-success)",
      bgColor: "bg-success/10",
      path: "/candidate-management"
    },
    {
      id: 3,
      title: "Company Profile",
      description: "Update company information",
      icon: "Building2",
      iconColor: "var(--color-accent)",
      bgColor: "bg-accent/10",
      path: "/company-profile"
    },
    {
      id: 4,
      title: "Job Listings",
      description: "View all posted jobs",
      icon: "Briefcase",
      iconColor: "var(--color-warning)",
      bgColor: "bg-warning/10",
      path: "/job-listings"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {actions?.map((action) => (
        <button
          key={action?.id}
          onClick={() => navigate(action?.path)}
          className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg transition-smooth hover:shadow-card hover:border-primary text-left"
        >
          <div className={`w-12 h-12 rounded-lg ${action?.bgColor} flex items-center justify-center flex-shrink-0`}>
            <Icon name={action?.icon} size={24} color={action?.iconColor} />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-1">{action?.title}</h4>
            <p className="text-xs text-muted-foreground">{action?.description}</p>
          </div>
          <Icon name="ChevronRight" size={18} className="text-muted-foreground flex-shrink-0" />
        </button>
      ))}
    </div>
  );
};

export default QuickActions;